import { render, staticRenderFns } from "./LinhaDeItemDeItem.vue?vue&type=template&id=ae0f4ea6&scoped=true"
import script from "./LinhaDeItemDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeItemDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeItemDeItem.vue?vue&type=style&index=0&id=ae0f4ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0f4ea6",
  null
  
)

export default component.exports